const OPERATIONAL_ERRORS = {
  AUTH_INVALID_CREDENTIALS: 'Credenciais invalidas. Verifique usuario e senha.',
  AUTH_SESSION_EXPIRED: 'Sessao expirada. Faca login novamente.',
  WS_DEGRADED: 'Conexao em degradacao. Aguarde reconexao automatica.',
  API_TIMEOUT: 'Servidor demorou para responder. Tente novamente.',
  API_UNAVAILABLE: 'Servico indisponivel no momento. Tente novamente em instantes.',
  UNKNOWN: 'Ocorreu um erro inesperado. Tente novamente.',
};

const mapOperationalError = (error) => {
  const status = error?.response?.status;
  if (status === 401) {
    return OPERATIONAL_ERRORS.AUTH_INVALID_CREDENTIALS;
  }
  if (error?.code === 'ECONNABORTED') {
    return OPERATIONAL_ERRORS.API_TIMEOUT;
  }
  if (status && status >= 500) {
    return OPERATIONAL_ERRORS.API_UNAVAILABLE;
  }
  return error?.message || OPERATIONAL_ERRORS.UNKNOWN;
};

export { OPERATIONAL_ERRORS, mapOperationalError };
